const baseFontSize: number = 16;

export const px = (sizeInPx: number) => sizeInPx / baseFontSize;
export const px2rem = (sizeInPx: number) => `${px(sizeInPx)}rem`;
